import * as React from "react";
import type { SVGProps } from "react";
const SvgIconPhone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <g clipPath="url(#clip0_10660_10477)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.59.82c-.2.03-.54.13-.72.21-.39.18-.52.28-1.76 1.52-1.43 1.42-2.17 2.2-2.3 2.38q-.42.65-.42 1.4c0 .33.03.53.11.8q.17.52.57.97.3.33.29.64 0 .17-.06.32c-.05.14-.13.23-2.55 2.65-2.78 2.78-2.6 2.62-2.95 2.64-.25.01-.42-.05-.62-.22-.4-.34-.73-.54-1.14-.66-.2-.06-.24-.06-.66-.06-.5 0-.65.02-1.03.19-.42.18-.5.24-2.22 1.94-1.64 1.63-1.73 1.72-1.9 1.97-.62.92-.57 2.16.13 3.03.18.23 1.11 1.13 1.39 1.35.86.7 1.77 1.08 2.9 1.26.37.06 1.24.06 1.62 0q1-.16 1.84-.57c.35-.18.47-.25 1.1-.7 4.55-3.16 8.56-7.16 11.7-11.7.44-.63.45-.64.6-.94q.57-1.05.68-2.32c.05-.63-.04-1.49-.22-2.12-.23-.76-.64-1.53-1.15-2.14-.29-.34-1.11-1.18-1.32-1.33-.55-.42-1.25-.6-1.91-.51m.02 1.76c-.13.05-.26.18-1.72 1.64-.87.87-1.62 1.63-1.66 1.7-.15.23-.17.53-.06.78l.2.29c.08.08.2.22.26.32.62.88.6 2.1-.06 2.96-.2.27-5.1 5.18-5.3 5.32-.67.46-1.47.6-2.22.38-.39-.11-.68-.28-1.03-.57-.1-.1-.25-.2-.31-.22q-.36-.16-.74.02c-.11.05-3.2 3.1-3.31 3.26q-.15.21-.14.52c.02.32.07.4.62.94.68.66.98.9 1.48 1.14.27.13.7.28 1.04.35.23.05.32.06.8.06.63 0 .82-.03 1.35-.2.47-.17.72-.3 1.4-.77 3.46-2.4 6.7-5.42 9.35-8.7.86-1.07 2.07-2.71 2.37-3.23.35-.6.52-1.22.54-1.95.03-.76-.1-1.39-.43-2.04-.25-.5-.46-.76-1.13-1.44-.55-.56-.6-.6-.94-.61-.19-.01-.23 0-.36.05"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_10660_10477">
        <rect width={24} height={24} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgIconPhone;
